<template>
<div class="container py-5">
    <div class="row align-items-start justify-content-start">
        <div class="col-lg-4">
            <CardPrensa
                :id="'maciel'"
                :name="'Matías Maciel'"
                :position="'Director de Asuntos Públicos, Comunicación y Sustentabilidad'"
                :email="'prensa.argentina@renault.com'"
                :photo="'/img/MatiasEduardoMaciel.jpg'"
            ></CardPrensa>
        </div>
        <div class="col-lg-4">
            <CardPrensa
                :id="'rivera'"
                :name="'Virginia Rivera'"
                :position="'Gerente de Comunicaciones'"
                :email="'prensa.argentina@renault.com'"
                :photo="'/img/VirginiaRivera.jpg'"
            ></CardPrensa>
        </div>
        <div class="col-lg-4">
            <CardPrensa
                :id="'ordonez'"
                :name="'Tomás Ordoñez'"
                :position="'Responsable de Comunicación Externa'"
                :email="'prensa.argentina@renault.com'"
                :photo="'/img/TomasOrdonez.jpg'"
            ></CardPrensa>
        </div>
    </div>
</div>

</template>

<script>
import CardPrensa from './CardPrensa.vue'
export default {
  components: { CardPrensa },
    
}
</script>